import styled from 'styled-components';
import React, { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';
import {
    Footer,
    FooterC,
    FooterHeader,
    LogoC,
    FPLogo,
    SocialC,
    FooterMain,
    CardFooter,
    CardFooter5,
    FooterRodape,
    Copy,
    Pagina,
    Titulo,
    ContainerEmail,
    ButtonEnviarEmail,
    PEmail,
    InputEmail,
    ContainerSeta,
    Paginas,
    BoxSeta,
    ContainerFooter,
    HeaderFooterSocial2
} from './Home.style.js';
import SetaAcordeon from '../components/svg/setaAcordeon.svg';

const StyledSVG = styled.img`
    transition: transform 0.3s ease;
    transform: rotate(${props => (props.isOpen ? '-180deg' : '0deg')});
    margin-left: 10px;
`;


function Rotape({ DadosAPI }) {

    //Navegacao lista de pordutos

    const navigate = useNavigate();

    const [openSections, setOpenSections] = useState({});

    const toggleSection = (index) => {
        setOpenSections((prevState) => ({
            ...prevState,
            [index]: !prevState[index],
        }));
    };

    const listafooter = [
        {
            id: "1",
            title: "Nossa missão",
            paginas: [
                {
                    title: `${DadosAPI.cabecalho[0].titulohome}`,
                    link: "www.x.com"
                }
            ]
        },
        {
            id: "2",
            title: "Dúvidas",
            paginas: [
                {
                    title: "Política de\n privacidade",
                    link: "www.x.com"
                },
                {
                    title: "Ajuda",
                    link: "www.x.com"
                },
                {
                    title: "Política de troca",
                    link: "www.x.com"
                },
                {
                    title: "Política de\n reembolso",
                    link: "www.x.com"
                }
            ]
        },
        {
            id: "3",
            title: "Contatos",
            paginas: [
                {
                    title: "WhatsApp",
                    link: `https://wa.me/55${DadosAPI.cabecalho[0].telefone.replace(/\D/g, '')}?text=Olá,%20gostaria%20de%20mais%20informações!`,
                }
            ]
        }
    ];

    return (
        <>
            <Footer>
                <FooterC>
                    <FooterHeader>
                        <HeaderFooterSocial2>
                            <LogoC>
                                <FPLogo><img style={{ width: 60, height: 60, objectFit: 'contain' }} src={DadosAPI.cabecalho[0].urllogo} /></FPLogo>
                            </LogoC>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <SocialC>
                                    {DadosAPI.redesocial[0] && (<a target="_blank" href={DadosAPI.redesocial[0].ecommerceredesocial}><img style={{ cursor: 'pointer', width: 25, height: 25 }} src={'https://w7.pngwing.com/pngs/636/380/png-transparent-black-instagram-logo-social-media-icons-thumbnail.png'} /></a>)}
                                    {DadosAPI.redesocial[1] && (<a target="_blank" href={DadosAPI.redesocial[1].ecommerceredesocial}><img style={{ cursor: 'pointer', width: 25, height: 25 }} src={'https://e7.pngegg.com/pngimages/729/946/png-clipart-facebook-like-button-computer-icons-social-icons-logo-internet.png'} /></a>)}
                                </SocialC>
                            </div>
                        </HeaderFooterSocial2>
                    </FooterHeader>
                    <FooterMain>
                        <ContainerFooter
                            style={{
                                gap: 20,
                                width: '90%',
                                flexWrap: 'wrap',
                                marginLeft: '10px',
                            }}>

                            {listafooter.map((section) => (
                                <CardFooter key={section.id || section.title}>
                                    <ContainerSeta onClick={() => toggleSection(section.id || section.title)}>
                                        <div>
                                            <Titulo>{section.title}</Titulo>
                                        </div>
                                        <div>
                                            <BoxSeta>
                                                <StyledSVG src={SetaAcordeon}
                                                    isOpen={!!openSections[section.id || section.title]} />
                                            </BoxSeta>
                                        </div>
                                    </ContainerSeta>
                                    <Paginas isOpen={!!openSections[section.id || section.title]}>

                                        {section?.paginas?.map((pagina, index) => (
                                            <Pagina key={index} style={{ whiteSpace: 'pre-line' }}>

                                                {pagina.title === "Recife Prata" ? (
                                                    // Se o título for "Recife Prata", não faz nada (não adiciona o onClick)
                                                    pagina.title
                                                ) : pagina.title === "WhatsApp" ? (<a
                                                    href={pagina.link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ textDecoration: 'none', color: 'inherit' }}>
                                                    {pagina.title}
                                                </a>) : (
                                                    // Se o título for diferente, adiciona o onClick para navegação
                                                    <span onClick={() => navigate('/politica-troca')} style={{ cursor: 'pointer' }}>
                                                        {pagina.title}
                                                    </span>
                                                )}

                                                {/* {pagina.title === "WhatsApp" && (
                                                    <a
                                                        href={pagina.link}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ textDecoration: 'none', color: 'inherit' }}>
                                                        {pagina.title}
                                                    </a>
                                                )} */}
                                            </Pagina>
                                        ))}
                                    </Paginas>
                                </CardFooter>
                            ))}

                            <CardFooter5>
                                <Titulo>{DadosAPI.pagina.titulo}</Titulo>
                                <ContainerEmail>
                                    <InputEmail><input type="email" placeholder="Seu e-mail" style={{ padding: '10px 20px', border: 'none', background: 'none', outline: 'none' }} /></InputEmail>
                                    <ButtonEnviarEmail style={{ background: 'black' }}><PEmail>Enviar</PEmail></ButtonEnviarEmail>
                                </ContainerEmail>
                                <Pagina style={{ marginLeft: '0', whiteSpace: 'pre-line' }}>{DadosAPI.pagina.subtitulo}</Pagina>
                            </CardFooter5>

                        </ContainerFooter>
                    </FooterMain>
                    <FooterRodape>
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '1050px' }}>
                            <Copy>Feito por: Baron Tech</Copy>
                        </div>
                    </FooterRodape>
                </FooterC>
            </Footer>
        </>
    );
}

export default Rotape;